export type DeliveryReasonTier = 'ACTIONABLE' | 'INHERITED'

export interface DeliveryReason {
    label: string
    tier: DeliveryReasonTier
}

const inherited = (label: string): DeliveryReason => ({ label, tier: 'INHERITED' })
const actionable = (label: string): DeliveryReason => ({ label, tier: 'ACTIONABLE' })

export const deliveryReasonOptions: Record<string, DeliveryReason> = {
    CAMPAIGN_PAUSED: inherited('Campaign Paused'),
    CAMPAIGN_ARCHIVED: inherited('Campaign Archived'),
    AD_GROUP_PAUSED: inherited('Ad Group Paused'),
    AD_GROUP_ARCHIVED: inherited('Ad Group Archived'),
    TARGET_PAUSED: inherited('Target Paused'),
    TARGET_ARCHIVED: inherited('Target Archived'),
    ADVERTISER_ARCHIVED: inherited('Advertiser Archived'),
    ADVERTISER_PAYMENT_FAILURE: actionable('Advertiser Payment Failure'),
    PORTFOLIO_OUT_OF_BUDGET: actionable('Portfolio Out Of Budget'),
    PORTFOLIO_END_DATE_REACHED: actionable('Portfolio End Date Reached'),
    CAMPAIGN_ENDED: actionable('Campaign Ended'),
    AD_GROUP_INCOMPLETE: actionable('Ad Group Incomplete'),
    CAMPAIGN_OUT_OF_BUDGET: actionable('Campaign Out Of Budget'),
    CAMPAIGN_INCOMPLETE: actionable('Campaign Incomplete'),
    ADVERTISER_OUT_OF_BUDGET: actionable('Advertiser Out Of Budget'),
    ADVERTISER_EXCEED_SPENDS_LIMIT: actionable('Advertiser Exceed Spends Limit'),
    CAMPAIGN_PENDING_START_DATE: actionable('Campaign Pending Start Date'),
    PORTFOLIO_PENDING_START_DATE: actionable('Portfolio Pending Start Date'),
}
